/**
 * Tool parameter validator
 * Validates tool parameters against their schemas
 */

import Ajv from 'ajv';
import type { JSONSchema7 } from 'json-schema';
import { ToolValidationError } from '../types';

const ajv = new Ajv();

/**
 * Validate tool parameters against schema
 */
export function validateToolParameters(
  schema: JSONSchema7,
  params: unknown
): { valid: boolean; errors?: string[] } {
  const validate = ajv.compile(schema);
  const valid = validate(params);

  if (!valid) {
    const errors = validate.errors?.map(err => {
      const path = (err as any).instancePath || 'root';
      return `${path}: ${err.message}`;
    }) || [];
    return { valid: false, errors };
  }

  return { valid: true };
}

/**
 * Validate and throw on error
 */
export function validateToolParametersOrThrow(
  schema: JSONSchema7,
  params: unknown,
  toolId: string
): void {
  const result = validateToolParameters(schema, params);
  if (!result.valid) {
    throw new ToolValidationError(
      'parameters',
      `Invalid parameters for tool "${toolId}": ${result.errors?.join(', ')}`,
      params
    );
  }
}
